// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nlabel[data-v-0a0b8b64] {\n  color: #3C4B64;\n}\n#depats[data-v-0a0b8b64]{\n  list-style: none;\n}\n.pointer[data-v-0a0b8b64]:hover {\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
